/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Toast_ErrorInputs */

const en_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your message couldn't be sent. Please try again or call us.`)
};

const es_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se pudo enviar tu mensaje. Inténtalo de nuevo o llámanos.`)
};

const de_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ihre Nachricht konnte nicht gesendet werden. Bitte versuchen Sie es erneut oder rufen Sie uns an.`)
};

const zh_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`消息发送失败。请重试或致电我们。`)
};

const ar_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تعذّر إرسال رسالتك. يرجى المحاولة مرة أخرى أو الاتصال بنا.`)
};

const fr_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre message n'a pas pu être envoyé. Veuillez réessayer ou nous appeler.`)
};

const vi_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không thể gửi tin nhắn của bạn. Vui lòng thử lại hoặc gọi cho chúng tôi.`)
};

const sw_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ujumbe wako haukuweza kutumwa. Tafadhali jaribu tena au utupigie simu.`)
};

const th_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่สามารถส่งข้อความของคุณได้ โปรดลองอีกครั้งหรือโทรหาเรา`)
};

const bs_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vaša poruka nije poslana. Pokušajte ponovo ili nas nazovite.`)
};

const ja_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メッセージを送信できませんでした。もう一度お試しいただくか、お電話ください。`)
};

const ko_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`메시지를 보내지 못했습니다. 다시 시도하시거나 전화로 문의해 주세요.`)
};

const pt_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não foi possível enviar sua mensagem. Tente novamente ou ligue para nós.`)
};

const it_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossibile inviare il messaggio. Riprova o chiamaci.`)
};

const sv_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meddelandet kunde inte skickas. Försök igen eller ring oss.`)
};

const nl_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je bericht kon niet worden verzonden. Probeer het opnieuw of bel ons.`)
};

const da_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din besked kunne ikke sendes. Prøv igen, eller ring til os.`)
};

const nb_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meldingen kunne ikke sendes. Prøv igjen eller ring oss.`)
};

const fi_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Viestin lähettäminen epäonnistui. Yritä uudelleen tai soita meille.`)
};

const pl_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie udało się wysłać wiadomości. Spróbuj ponownie lub zadzwoń do nas.`)
};

const ru_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Не удалось отправить сообщение. Попробуйте ещё раз или позвоните нам.`)
};

const tr_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesajınız gönderilemedi. Lütfen tekrar deneyin veya bizi arayın.`)
};

const hi_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आपका संदेश नहीं भेजा जा सका। कृपया फिर से कोशिश करें या हमें कॉल करें।`)
};

const id_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Anda tidak dapat dikirim. Silakan coba lagi atau hubungi kami melalui telepon.`)
};

const ms_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mesej anda tidak dapat dihantar. Sila cuba lagi atau hubungi kami melalui telefon.`)
};

const cs_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zprávu se nepodařilo odeslat. Zkuste to prosím znovu nebo nám zavolejte.`)
};

const el_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δεν ήταν δυνατή η αποστολή του μηνύματός σας. Δοκιμάστε ξανά ή καλέστε μας.`)
};

const he_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא ניתן היה לשלוח את ההודעה. נסו שוב או התקשרו אלינו.`)
};

const af_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jou boodskap kon nie gestuur word nie. Probeer asseblief weer of bel ons.`)
};

const hu_contact_toast_error = /** @type {(inputs: Contact_Toast_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az üzenetet nem sikerült elküldeni. Kérjük, próbálja újra, vagy hívjon minket.`)
};

/**
* | output |
* | --- |
* | "Your message couldn't be sent. Please try again or call us." |
*
* @param {Contact_Toast_ErrorInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const contact_toast_error = /** @type {((inputs?: Contact_Toast_ErrorInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Toast_ErrorInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_contact_toast_error(inputs)
	if (locale === "de") return de_contact_toast_error(inputs)
	if (locale === "zh") return zh_contact_toast_error(inputs)
	if (locale === "ar") return ar_contact_toast_error(inputs)
	if (locale === "fr") return fr_contact_toast_error(inputs)
	if (locale === "vi") return vi_contact_toast_error(inputs)
	if (locale === "sw") return sw_contact_toast_error(inputs)
	if (locale === "th") return th_contact_toast_error(inputs)
	if (locale === "bs") return bs_contact_toast_error(inputs)
	if (locale === "ja") return ja_contact_toast_error(inputs)
	if (locale === "ko") return ko_contact_toast_error(inputs)
	if (locale === "pt") return pt_contact_toast_error(inputs)
	if (locale === "it") return it_contact_toast_error(inputs)
	if (locale === "sv") return sv_contact_toast_error(inputs)
	if (locale === "nl") return nl_contact_toast_error(inputs)
	if (locale === "da") return da_contact_toast_error(inputs)
	if (locale === "nb") return nb_contact_toast_error(inputs)
	if (locale === "fi") return fi_contact_toast_error(inputs)
	if (locale === "pl") return pl_contact_toast_error(inputs)
	if (locale === "ru") return ru_contact_toast_error(inputs)
	if (locale === "tr") return tr_contact_toast_error(inputs)
	if (locale === "hi") return hi_contact_toast_error(inputs)
	if (locale === "id") return id_contact_toast_error(inputs)
	if (locale === "ms") return ms_contact_toast_error(inputs)
	if (locale === "cs") return cs_contact_toast_error(inputs)
	if (locale === "el") return el_contact_toast_error(inputs)
	if (locale === "he") return he_contact_toast_error(inputs)
	if (locale === "af") return af_contact_toast_error(inputs)
	if (locale === "hu") return hu_contact_toast_error(inputs)
	return en_contact_toast_error(inputs)
});